import React from "react";
import "./Hero.css";
import computerImg from "./assets/computer.png"; 
import websitedev from "./assets/websitedev.png";

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-container">

        {/* Left Content */}
        <div className="hero-text">
          <h1>
            Welcome to <span>NextEdge</span>
          </h1>
          <p>
            We design and build modern websites & applications that help your
            business grow. Let’s create something amazing together.
          </p>
          <div className="hero-buttons">
            <a href="#services" className="btn btn-primary">Our Services</a>
            <a href="#contact" className="btn btn-outline">Contact Us</a>
          </div>
        </div>

        {/* Right Image */}
        <div className="hero-image">
        <img src={computerImg} alt="NextEdge Computer" />
        <img src={websitedev} alt="website "></img>
        </div>

      </div>
    </section>
  );
};

export default Hero;
